module.exports = require("lodash/maxBy");


//////////////////
// WEBPACK FOOTER
// external "lodash/maxBy"
// module id = 45
// module chunks = 0